import analyticstracker from "@jmc/analyticstracker";
import { useCookieInteraction } from "@jmc/core/src/hooks/useCookieInteraction/index";
import { EventTypes } from "@jmc/core/src/types/EventTypes";
import { useOnScreen } from "@jmc/utils/hooks/useOnScreen";
import React, { useEffect, useRef } from "react";

export interface PropTypes {
    children: JSX.Element | JSX.Element[];
    name: string;
    position: number;
}

export const SectionImpression: React.FunctionComponent<PropTypes> = (props: PropTypes) => {
    const { interacted } = useCookieInteraction();
    const { children, name, position } = props;
    const sectionContainer = useRef<HTMLDivElement>(null);
    const inViewport = useOnScreen(sectionContainer);

    useEffect(() => {
        if (inViewport && interacted) {
            setTimeout(() => {
                analyticstracker().trackImpression(EventTypes.SECTION_IMPRESSION);
            }, 1000);
        }
    }, [inViewport, interacted]);

    return (
        <div
            role="none"
            data-tracking-event={EventTypes.SECTION_IMPRESSION}
            data-tracking-info={JSON.stringify({ name, position })}
            data-test-id={`sectionimpression.${name}.${position}`}
            ref={sectionContainer}
        >
            {children}
        </div>
    );
};
